import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ProfessionalRfpListView } from '@/components/pages/rfp/professional/ProfessionalRfpListView/ProfessionalRfpListView';
import Layout from '@/container/Layout';
/**
 * コンサルタント：案件一覧のページ全体を表示するためのコンポーネント
 * @param props
 * @constructor
 */
export const RfpProfessionalListPage = (props) => {
    const { loading, onChangeSort, rfps, sort } = props;
    return (_jsx(Layout, Object.assign({ mainClassName: 'l-main rfp_list_container rfp_common_container' }, { children: _jsx(ProfessionalRfpListView, { loading: loading, onChangeSort: onChangeSort, rfps: rfps, sort: sort }) })));
};
